import { PositionResource, SelectedAccountOrClient, useCollateralSummaryCommon } from '@eih-netbroker/common';
import { useAtomValue } from 'jotai/index';
import { useCallback, useMemo } from 'react';
import { useResource, useResourceHeaders } from '../../../shared/services/useResource';
import { primaryInstanceAtom } from '../../../shared/state/primaryInstanceAtom';

export const useCollateralSummary = (selectedAccountOrClient?: SelectedAccountOrClient) => {
  const positionResource = useResource(PositionResource);
  const { getResourceHeaderForClient } = useResourceHeaders();
  const isPrimaryInstance = useAtomValue(primaryInstanceAtom);

  const p = useMemo(
    () => ({
      positionResource,
      getResourceHeaderForClient,
      selectedAccountOrClient,
    }),
    [positionResource, getResourceHeaderForClient, selectedAccountOrClient],
  );

  const { loadCollateralSummary, ...props } = useCollateralSummaryCommon(p);

  const loadCollateralSummaryWeb = useCallback(
    (force?: boolean) => {
      if (!isPrimaryInstance) {
        // do not load collateral summary, since this is a shared atom between browser tabs, the primary instance will load it
        return Promise.resolve();
      }
      return loadCollateralSummary(force);
    },
    [loadCollateralSummary, isPrimaryInstance],
  );

  return {
    loadCollateralSummary: loadCollateralSummaryWeb,
    ...props,
  };
};
